import { useMemo } from 'react'
import { DataChart } from '../ChartWrapper'

type UseRegionTooltipContentProps = {
  data: DataChart
}

type TooltipResult = {
  html: string
  title: string
  estimatedHeight: number
  totalAmount: number
}

export type TooltipDictionary = Record<string, TooltipResult>

const useRegionTooltipContent = ({
  data
}: UseRegionTooltipContentProps): TooltipDictionary => {
  return useMemo(() => {
    // Helper function to normalize region keys uniformly
    const normalizeKey = (key: string) =>
      key
        .replace('centro-oeste', 'centroOeste')
        .replace('Centro-Oeste', 'centroOeste')
        .toLowerCase()

    const tooltips: TooltipDictionary = {}

    const dataWithoutHeader = data.slice(1) // Remove header row

    for (const row of dataWithoutHeader) {
      const regionKeyRaw = row[0]
      if (!regionKeyRaw || !row[2]) {
        continue
      }

      const normalizedKey = normalizeKey(regionKeyRaw)

      const header = row[2]?.[0]
      const title = header?.[0] || ''
      const actionsData = row[2].slice(1) // skip header at index 0
      if (!actionsData.length) {
        tooltips[normalizedKey] = {
          html: '',
          estimatedHeight: 0,
          title: '',
          totalAmount: 0
        }
        continue
      }

      let html = `<ul style="list-style: none;padding:0px;margin:0;">`
      let totalAmount = 0
      for (const regionActionData of actionsData) {
        const label = regionActionData[0]
        const amount = regionActionData[1]
        totalAmount += Number(amount)
        html += `<li>${amount} | ${label}</li>`
      }
      html += '</ul>'

      // Calculating estimated height for this region's tooltip
      const numLines = actionsData.length + 1 // +1 for title or header line
      const lineHeight = 16
      const estimatedHeight = numLines * lineHeight

      tooltips[normalizedKey] = {
        html,
        estimatedHeight,
        title,
        totalAmount
      }
    }

    return tooltips
  }, [data])
}

export default useRegionTooltipContent
